import { render } from "./announcement-bar.vue?vue&type=template&id=fe9aa76e"
import script from "./announcement-bar.vue?vue&type=script&lang=js"
export * from "./announcement-bar.vue?vue&type=script&lang=js"

import "./announcement-bar.vue?vue&type=style&index=0&id=fe9aa76e&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__